import React from 'react';
import { useTranslation } from 'react-i18next';

import { withJobContext } from 'src/utils/context/JobContext';
import Style from 'src/components/JobChecklistForm/JobChecklistForm.styles';

const ResultSectionToggleButtonsComponent = ({
  jobContext,
  activeReportReviewNote,
  addNote,
  isCreateNote,
  isUnderReviewing,
  selectedQuestion,
  setShowHistory,
  setShowNote,
  setShowResult,
  showNote,
  showResult,
}) => {
  const { t } = useTranslation();

  const {
    user: {
      isAuditor,
      isReportReviewer,
      isInternalUser,
    },
    permissions: {
      isReportNotesAvailableToAuditor,
    },
  } = jobContext;

  return (
    <Style.AddNoteButtonWithTitleDiv noFlex={!!activeReportReviewNote}>
      <Style.QuestionTitle>
        {t('DATASHEET')} {selectedQuestion.questionNumber}
      </Style.QuestionTitle>
      {isInternalUser && (
        <Style.GreySwitchButton
          onClick={() => {
            setShowResult(true);
            setShowNote(false);
            setShowHistory(false);
          }}
          selected={showResult}
        >
          {t('RESULT')}
        </Style.GreySwitchButton>
      )}
      {activeReportReviewNote && (
        <Style.GreySwitchButton
          onClick={() => {
            setShowResult(false);
            setShowNote(true);
            setShowHistory(false);
          }}
          selected={showNote}
        >
          {t('REVIEW_NOTES')}
        </Style.GreySwitchButton>
      )}
      {((isUnderReviewing && isReportReviewer) || (isReportNotesAvailableToAuditor && isAuditor)) &&
      !isCreateNote &&
      !activeReportReviewNote && (
        <Style.AddButtonWrapper onClick={() => {
          setShowHistory(false);
          addNote();
        }}>
          <Style.AddButton name="plus" />
          <Style.AddButtonLabel>{t('ADD_NOTE')}</Style.AddButtonLabel>
        </Style.AddButtonWrapper>
      )}
    </Style.AddNoteButtonWithTitleDiv>
  );
};

export const ResultSectionToggleButtons = React.memo(withJobContext(ResultSectionToggleButtonsComponent));